// Generated by CoffeeScript 2.7.0
var DataTableMixin;

import Popover from 'trunks/vue/admin/components/libs/popover.js';

import {
  FieldHeaderCell,
  FieldCell
} from 'trunks/vue/admin/components/fields_cell/cell.js';

import FilterChip from 'trunks/vue/admin/components/filter_chips/index.js';

import Paginator from 'trunks/vue/admin/components/paginator.js';

import ResponsiveTable from 'trunks/vue/admin/components/responsive_table.js';

import AttachmentLayer from 'trunks/vue/admin/compositions/attachment_layer.js';

import {
  newSpinner
} from 'trunks/vue/admin/components/spinner.js';

export default DataTableMixin = {
  components: {
    paginator: Paginator,
    'v-table': ResponsiveTable,
    'field-cell': FieldCell,
    'header-cell': FieldHeaderCell,
    'filter-chip': FilterChip,
    popover: Popover
  },
  props: {
    fieldable: {
      type: Skylark.App.Model.BaseModel
    },
    datableGID: {
      type: Skylark.Libs.GlobalID,
      required: true
    },
    cellWidth: {
      type: Number,
      default: 200
    },
    preserveredFilters: {
      type: Object,
      default: function() {
        return null;
      }
    },
    additionalParams: {
      type: Object,
      default: function() {
        return {};
      }
    },
    totalRecordCount: {
      type: Number
    },
    // 用于视图设置总的可见fields
    visibleFieldIds: {
      type: Array,
      default: function() {
        return null;
      }
    }
  },
  data: function() {
    return {
      fields: [],
      recordRows: [],
      records: [],
      totalCount: 0,
      filters: {},
      // eg:
      // filters:
      //   field_id: { value: search_value, field: field }
      order: {},
      searchParams: {},
      composedPreservedFilters: {},
      preserveredFiltersShown: false,
      fixedColumnIds: []
    };
  },
  computed: {
    filterFields: function() {
      return _.filter(this.fields, function(field) {
        return !field._hidden;
      });
    },
    filtersExist: function() {
      return Boolean(_.keys(this.filters).length);
    },
    paginatorParams: function() {
      var searchParams;
      searchParams = this.filtersExist || this.order.value ? this.searchParams : {};
      return _.extend(searchParams, this.additionalParams);
    },
    fieldsAllSelected: function() {
      return _.every(this.fields, function(field) {
        return !field._hidden;
      });
    },
    attachments: function() {
      return _.reduce(this.records, function(result, record) {
        _.each(record.entries, function(entry) {
          if (entry.attachment) {
            return result = result.concat(_.extend(entry.attachment, {
              author: record.user,
              response: record
            }));
          }
        });
        return result;
      }, []);
    },
    hasRecords: function() {
      return Boolean(this.records.length);
    }
  },
  created: function() {
    this.fields = this._parseFields();
    this.filters = this._parseFilters();
    this.composedPreservedFilters = this._parsePreservedFilters();
    return this._bindCacheEvent();
  },
  watch: {
    filters: function() {
      return this.searchParams = this._generateSearchParams();
    },
    order: function() {
      return this.searchParams = this._generateSearchParams();
    },
    paginatorParams: function() {
      return this.refreshData();
    },
    paginatorUrl: function() {
      return this.refreshData();
    }
  },
  destroyed: function() {
    return this._removeCacheEventListener();
  },
  methods: {
    toggleHideField: function(field) {
      field._hidden = !field._hidden;
      return this._refreshTable();
    },
    invertSelectFieldsFunc: function() {
      _.each(this.fields, function(field) {
        return field._hidden = !field._hidden;
      });
      return this._refreshTable();
    },
    selectAllFieldsFunc: function() {
      _.each(this.fields, function(field) {
        return field._hidden = false;
      });
      return this._refreshTable();
    },
    exportAll: function() {
      return this.export({
        field_ids: _.pluck(this.fields, 'id')
      });
    },
    export: function(export_options) {
      this.$refs.exportPopover.close();
      if (this._exportRequesting) {
        return;
      }
      this._exportRequesting = true;
      return Skylark.Libs.Ajax.get(`${this.datableUrl}/responses/export?enhanced=1`, {
        data: export_options,
        responseType: 'script',
        complete: () => {
          return this._exportRequesting = false;
        }
      });
    },
    exportDisplayed: function() {
      return this.export({
        field_ids: _.pluck(this.filterFields, 'id')
      });
    },
    // 所有records
    updateRecords: function(records, status) {
      this.records = this._formatRecords(records);
      this.totalCount = status.totalCount || 0;
      this.recordRows = this._parseRecords(records, status.currentPerPage);
      this.$refs.bodyTable.scrollTableIntoView();
      return this.$nextTick(function() {
        return this.$emit('recordsChanged', this.totalCount);
      });
    },
    // 单条record
    updateRecord: function(record) {
      var new_recordRow, record_index, row_record_index;
      record_index = _.findIndex(this.records, function(_record) {
        return _record.id === record.id;
      });
      new_recordRow = this.__parseRecordToRow(record);
      row_record_index = _.findIndex(this.recordRows, function(_recordRow) {
        return _recordRow.id === new_recordRow.id;
      });
      this.records.splice(record_index, 1, record);
      this.recordRows.splice(row_record_index, 1, new_recordRow);
      return this.$nextTick(function() {
        return this.$emit('recordChanged', record);
      });
    },
    removeOrUpdateFilter: function(search_value, field) {
      if (search_value) {
        Vue.set(this.filters, field.id, {
          value: search_value,
          field: field
        });
        return this.searchParams = this._generateSearchParams();
      } else {
        return this._removeFilter(field.id);
      }
    },
    cacheFilterSettings: function() {
      var cached_filters;
      cached_filters = _.reduce(this.filters, (filter_memo, filter) => {
        var filter_value;
        filter_memo[filter.field.id] = _.contains([-6, -8], filter.field.id) ? (filter_value = _.map(filter.value, function(item) {
          return _.pick(item, 'value');
        }), {
          value: filter_value
        }) : _.pick(filter, 'value');
        return filter_memo;
      }, {});
      return sessionStorage.setItem(`${this.datableUrl}_cached_filters`, JSON.stringify(cached_filters));
    },
    removeOrUpdateOrder: function(order, field) {
      return this.order = {
        value: order,
        field: field
      };
    },
    displayItemIfNeed: function(event, item) {
      if (event.target.closest('.attachment-item')) {
        return this.displayAttachmentIfNeed(item);
      }
    },
    displayAttachmentIfNeed: function(attachment) {
      var attahcmentLayer;
      attahcmentLayer = new AttachmentLayer({
        el: Skylark.Helpers.Utilities.getOrCreateCleaningElementByIdForVue('layer_container'),
        data: {
          attachments: this.attachments,
          currentIndex: _.indexOf(this.attachments, attachment)
        }
      });
      return attahcmentLayer.$on('afterClosed', () => {
        return this.$refs.bodyTable.focusOnRow(this._findRecordRowByRecord(attahcmentLayer.currentAttachment.response));
      });
    },
    removeFilter: function(filter) {
      var ref;
      return this._removeFilter((ref = filter.field) != null ? ref.id : void 0);
    },
    refreshData: _.debounce(function() {
      if (!this.spinner) {
        this.spinner = this._recordsRequestSpinner();
      }
      return this.$refs.paginator.go(1);
    }, 100),
    cacheSettings: function() {
      this.cacheFilterSettings();
      return this.cacheHiddenSettings();
    },
    cacheHiddenSettings: function() {
      var hidden_ids;
      hidden_ids = _.chain(this.fields).filter(function(field) {
        return field._hidden;
      }).pluck('id').value().join(',');
      return localStorage.setItem(`${this.datableUrl}_hiddensetting_draft`, hidden_ids);
    },
    restoreHiddenSettings: function() {
      var hidden_ids;
      hidden_ids = localStorage.getItem(`${this.datableUrl}_hiddensetting_draft`);
      if (!hidden_ids) {
        return [];
      }
      return _.map(hidden_ids.split(','), function(id) {
        return parseInt(id);
      });
    },
    togglePreserveredFiltersFunc: function() {
      return this.preserveredFiltersShown = !this.preserveredFiltersShown;
    },
    beforeRecordsRequestFunc: function() {
      if (!this.spinner.opened) {
        return this.spinner.open();
      }
    },
    afterRecordsRequestFunc: function() {
      return this.spinner.close();
    },
    _findRecordRowByRecord: function(record) {
      return _.find(this.recordRows, function(row) {
        return row.id === record.id;
      });
    },
    _refreshTable: function() {
      return this.recordRows = this._parseRecords(this.records, this.$refs.paginator.currentPerPage);
    },
    _bindCacheEvent: function() {
      // Chrome 已拦截 unload；pagehide 是替代事件，移动端也支持。
      return window.addEventListener('pagehide', this.cacheSettings, false);
    },
    _removeCacheEventListener: function() {
      return window.removeEventListener('pagehide', this.cacheSettings, false);
    },
    _removeFilter: function(key) {
      return Vue.delete(this.filters, key);
    },
    _generateSearchParams: function() {
      return {
        query: this.__generateQueryParams(),
        order: this.__generateOrderParams()
      };
    },
    _getFilterByField: function(field) {
      return this.filters[field.id];
    },
    _parseFields: function() {
      var hidden_ids, result;
      hidden_ids = this.restoreHiddenSettings();
      result = _.chain(this.fieldable.fields).map(function(field) {
        if (/Detail/.test(field.type)) {
          return _.chain(field.children).sortBy('position').value();
        } else {
          return field;
        }
      }).flatten(true).each(function(field) {
        return Vue.set(field, '_hidden', _.contains(hidden_ids, field.id));
      }).value();
      this._addSpecialFields(result, hidden_ids);
      return _.filter(result, (field) => {
        if (field.type === 'Field::SectionBreak') {
          return false;
        }
        if (!this.visibleFieldIds) {
          return true;
        }
        return _.contains(this.visibleFieldIds, field.id);
      });
    },
    _parseFilters: function() {
      var cached_filters;
      cached_filters = JSON.parse(sessionStorage.getItem(`${this.datableUrl}_cached_filters`)) || {};
      return _.reduce(cached_filters, (memo, filter_value, field_id) => {
        var field, filter;
        field_id = Number(field_id);
        filter = _.clone(filter_value);
        field = _.find(this.fields, function(field) {
          return field.id === field_id;
        });
        if (!field) {
          return memo;
        }
        filter.field = field;
        // 判断当前字段是否为当前节点或流程状态
        if (_.contains([-6, -8], field_id)) {
          // 遍历value，流程状态节点或当前节点的字段为父级的field，逾期节点的字段为父级field的addition属性字段
          filter.value = _.map(filter.value, function(item) {
            var filter_item;
            filter_item = _.clone(item);
            filter_item.field = _.contains(["overdued", "unoverdued"], item.value.id) ? filter.field.addition : filter.field;
            return filter_item;
          });
        }
        memo[field_id] = filter;
        return memo;
      }, {});
    },
    _parsePreservedFilters: function() {
      return _.reduce(this.preserveredFilters, (memo, value, field_id) => {
        var field;
        field = _.findWhere(this.fields, {
          id: parseInt(field_id)
        });
        if (!field) {
          return memo;
        }
        return _.tap(memo, function(obj) {
          return obj[field_id] = {
            value: value,
            field: field
          };
        });
      }, {});
    },
    _parseRecords: function(records, currentPerPage) {
      var empty_record, new_records;
      new_records = _.map(records, this.__parseRecordToRow);
      empty_record = this.__parseRecordToRow({
        entries: [],
        user: null
      });
      while (currentPerPage - new_records.length > 0) {
        new_records.push({
          _selected: false,
          children: [
            {
              _uid: Skylark.Helpers.Utilities.uuid(),
              cells: empty_record.children[0].cells
            }
          ]
        });
      }
      return new_records;
    },
    __parseRecordToRow: function(record) {
      var field_grouped_entries_hsh, grouped_entries_hsh, normal_entries, record_entries, result, row, rowspan;
      // table-row 数据
      // 一个 row 拥有多个 child_row（子行）
      // child_row 拥有多个 cells
      result = {
        user: record.user,
        id: record.id,
        _selected: false,
        children: [],
        read: record.hasOwnProperty('read') && record.read,
        record: record
      };
      // 隐藏的列不再参与计算
      record_entries = _.filter(record.entries, (entry) => {
        return _.contains(_.pluck(this.filterFields, 'id'), entry.field_id);
      });
      grouped_entries_hsh = _.groupBy(record_entries, 'detail_id');
      field_grouped_entries_hsh = _.groupBy(record_entries, 'field_id');
      normal_entries = grouped_entries_hsh[null];
      delete grouped_entries_hsh[null];
      rowspan = 1;
      _.each(grouped_entries_hsh, function(grouped_entries) {
        var length;
        length = _.keys(_.groupBy(grouped_entries, 'group_id')).length;
        if (rowspan < length) {
          return rowspan = length;
        }
      });
      // geted max group number of a record
      result.rowspan = rowspan;
      row = 0;
      // TODO: 优化下面拆分 record 的代码
      // 一条 record 将被拆分成它的最大 detail/group 数量的假 ‘record’
      while (row < rowspan) {
        result.children.push({
          _uid: Skylark.Helpers.Utilities.uuid(),
          cells: _.chain(this.filterFields).map((field) => {
            var _result;
            _result = {
              field: field,
              cell_id: field.id
            };
            this.__parseSpecialCells(field, record, field_grouped_entries_hsh, row, _result);
            if (!field.detail_id) {
              if (row < 1 && _result) {
                _result.rowspan = rowspan;
              } else {
                _result = null;
              }
            }
            return _result;
          }).compact().value()
        });
        row += 1;
      }
      return result;
    },
    __generateQueryParams: function() {
      return _.reduce(this.filters, function(memo, filter, key) {
        var current_filter, filterValue;
        filterValue = (function() {
          switch (filter.field.type) {
            case 'Field::RadioButton':
            case 'Field::CheckBox':
            case 'HoldField::Yaw::AssignmentStatus':
              return _.pluck(filter.value, 'id');
            case 'HoldField::Yaw::AssignmentDurationThreshold':
              return filter.value.id;
            case 'HoldField::Yaw::VertexName':
            case 'HoldField::Yaw::JourneyStatus':
              current_filter = {};
              _.each(filter.value, function(_filter) {
                if (_filter.field === filter.field) {
                  current_filter = _filter;
                  return;
                }
                if (_filter.value) {
                  return memo[_filter.field.id] = _filter.value.id;
                }
              });
              return current_filter.value;
            case 'Field::UserItem':
              key = 'keyword';
              return filter.value;
            case 'Field::TextField':
              if (parseInt(key) === -4) {
                key = 'phone';
              }
              return filter.value;
            default:
              return filter.value;
          }
        })();
        memo[key] = filterValue;
        return memo;
      }, {});
    },
    __generateOrderParams: function() {
      return _.tap({}, (params) => {
        if (this.order.value) {
          return params[this.order.field.id] = this.order.value;
        }
      });
    },
    __parseNormalCells: function(field, record, grouped_entries_hsh, rowspan, receivier) {
      var cell_entries, field_entries, group_id;
      field_entries = grouped_entries_hsh[field.id] || [];
      if (field.detail_id) {
        grouped_entries_hsh = _.groupBy(field_entries, 'group_id');
        group_id = _.keys(grouped_entries_hsh)[rowspan];
        cell_entries = group_id ? grouped_entries_hsh[group_id] : [];
        receivier.rowspan = 1;
        return receivier.entries = cell_entries;
      } else {
        return receivier.entries = field_entries;
      }
    },
    _recordsRequestSpinner: function() {
      return newSpinner({
        parent: this.$el
      });
    }
  }
};
